import { render, staticRenderFns } from "./pwa_news_groups.vue?vue&type=template&id=28ef410e&scoped=true&"
import script from "./pwa_news_groups.vue?vue&type=script&lang=js&"
export * from "./pwa_news_groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef410e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ef410e')) {
      api.createRecord('28ef410e', component.options)
    } else {
      api.reload('28ef410e', component.options)
    }
    module.hot.accept("./pwa_news_groups.vue?vue&type=template&id=28ef410e&scoped=true&", function () {
      api.rerender('28ef410e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/groups/pwa_news_groups.vue"
export default component.exports